module.exports = __webpack_public_path__ + "static/media/building.9dd954c4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/building.jpeg
// module id = 244
// module chunks = 0